import React, {Component} from 'react';
import {config} from "./tool-config";

export const HEIGHT = 60;
const allComponents = [];
class EditorToolsSpace extends Component {

    pushComponent = (itemComponent)=>{
        let has = false;
        for(let i = 0 ; i < allComponents.length; i++){
            let item = allComponents[i];
            if(item === itemComponent){
                has = true;
            }
        }
        if(!has && itemComponent){
            allComponents.push(itemComponent);
        }
    };

    getComponentByName = (componentName)=>{
        for(let i = 0 ; i < allComponents.length; i++){
            let item = allComponents[i];
            if(typeof item.getName === "function"){
                if(item.getName().toUpperCase() === componentName.toUpperCase()){
                    return item;
                }
            }
        }
        return null;
    };

    /**
     * 获取工具组件
     */
    getToolComponent = (componentName, props = {})=>{
        let CustomComponent = require(`./tools/${componentName}/${componentName}.js`).default;
        return <CustomComponent ref={(itemComponent)=>{
            this.pushComponent(itemComponent);
        }} {...props} />;
    };

    /**
     * 监听内容变化
     */
    listenContentChange(){
        for(let i = 0 ; i < allComponents.length; i++){
            let item = allComponents[i];
            if(item){
                if(typeof item.listenContentChange === "function"){
                    item.listenContentChange();
                }
            }
        }
    }
    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        for(let i = 0 ; i < allComponents.length; i++){
            let item = allComponents[i];
            if(item){
                if(typeof item.listenContentClick === "function"){
                    item.listenContentClick();
                }
            }
        }
    }


    render() {
        let spaceComponents = [];
        config.map(item =>{
            for(let space in item){
                let SpaceComponent = require(`./${space}.js`).default;
                spaceComponents.push(<SpaceComponent contentChange={()=>{}} dynamicParams={this.props.dynamicParams} tools={item[space]} />);
            }
        });
        return (
            <div style={{padding:"5px 0"}}>
                {spaceComponents.map((item, index)=>{
                    let borderRight = index === (spaceComponents.length - 1) ? "":"1px solid rgba(0, 0, 0, 0.15)";
                    return <div key={index} style={{float:"left", borderRight}}>{item}</div>
                })}
            </div>
        );
    }
}

export default EditorToolsSpace;